import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {setColorScheme, setTheme} from "mdui";
import 'mdui'
import 'mdui/mdui.css'
import './index.css'

setColorScheme('#68548E');
setTheme("auto")

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);